// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { sendXHR, failedRequest } from "src/lib/utils";
import { isDevelopment} from "src/lib/utils";
import { getStorage, setStorage, deleteStorage } from "src/lib/storage";


// Stateful components

export class Poll extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            active: false,
            submit_error: false,
            results_error: false,
            show_results: false,
            results: {}
        };

        this.keypressHandler = this.keypressHandler.bind(this);
        this.clickSubmitHandler = this.clickSubmitHandler.bind(this);
        this.togglePollModal = this.togglePollModal.bind(this);
        this.submitPolls = this.submitPolls.bind(this);
    }


    componentDidMount() {
        var this_component = this;

        var polls_complete = this_component.getCompletePollIds();
        if (polls_complete !== null) {
            this_component.checkForResults();
        }
        
    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;
        var results = this_component['state']['results'];
        var active = this_component['state']['active'];

        if (prev_state['results'] !== results & active) {
            this_component.updateModalContent();
        }

        if (prev_state['submit_error'] !== this_component['state']['submit_error'] && this_component['state']['submit_error'] === true) {
            this_component.updateModalContent();
        }
    }



    // 
    // Events
    //

    togglePollModal(e) {
        e.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var active = !this['state']['active'];
        this.setState({
            active: active
        });

        // If opening the poll
        if (active) {
            this_component.updateModalContent();
        
        // If closing the poll
        } else {
            helpers.closeModal(e);
        }
        
    }

    keypressHandler(e) {
        e.preventDefault();
        var this_component = this;

        // ENTER
        if (e.keyCode === 13) {
            this_component.submitPolls();
        }
    }

    clickSubmitHandler(e) {
        e.preventDefault();
        var this_component = this;
        this_component.submitPolls();
    }

    


    //
    // Functions
    //

    getPoll() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        var user_personalisation = portal_context['user_personalisation'];

        var filtered_polls = [];
        var all_polls = configuration['poll']['poll_list'];
        if (all_polls) {
            filtered_polls = sq_personalise.fn.filterItems(all_polls, user_personalisation['attributes']);
        }

        if (filtered_polls.length > 0) {
            return filtered_polls[0];
        }

        return null;
    }

    getCompletePollIds() {
        var poll_ids = null;
        
        if (squiz !== undefined) {
            var all_storage = squiz.fn.getStorage('getallstorage', 'session', 'json');
            if (all_storage) {
                var polls_complete = all_storage['data']['pollscomplete'];
                if (polls_complete) {
                    poll_ids = polls_complete['poll_ids'];
                }
            }
        }

        return poll_ids;
    }

    updateModalContent () {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        
        deleteStorage('cookie', 'spw_0', '');

        var has_results = this['state']['show_results'];
        var title = has_results ? 'Poll results' : 'Poll of the day';
        
        var modal_content = this_component.renderModalContent();

        // Get modal data
        var modal_data = {
            'title': title,
            'class': 'modal-poll',
            'content': modal_content,
            'buttons': '',
            'closeCallback': function() {
                this_component.setState({
                    active: false
                });
            }
        };

        // Set modal content and display
        helpers.setModalContent(modal_data);
        portal_context['helpers']['closeMobileNav']();
    }

    checkForResults() {
        var this_component = this;
        var polls_complete = this_component.getCompletePollIds();
        var poll_to_render = this_component.getPoll();
        
        if (poll_to_render !== null) {
            var question_ids = this_component.getQuestionIds(poll_to_render);
        
            if (polls_complete !== null) {
                polls_complete.forEach(function(completed_poll) {
                    if (completed_poll.id == question_ids[0]) {
                        this_component.getResults(completed_poll);
                        if (!this_component['state']['show_results']) {
                            this_component.setState({
                                show_results: true,
                            });
                        }
                    }
                });
            }
        }
    }

    getResults(poll) {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        if (poll.qid !== undefined) {

            if (isDevelopment()) {
                this_component.setState({
                    results: {
                        question_name: 'Timetable question 20180322',
                        data: [
                            {"count":"487","response":"Very satisfied","percent_total":"21.92"},{"count":"865","response":"Satisfied","percent_total":"38.93"},{"count":"393","response":"Neither satisfied nor dissatisfied","percent_total":"17.69"},{"count":"338","response":"Dissatisfied","percent_total":"15.21"},{"count":"139","response":"Very dissatisfied\u200b","percent_total":"6.26"}
                        ]
                    }
                });
            } else {
                var request_url = configuration["poll"]["poll_results"] + "?pollid=" + poll.id + "&pollq=" + poll.qid;
        
                var xhr_parameters = {
                    'request_url': request_url,
                    'request_success': function(response) {
                        var html_obj = document.createElement('div');
                        html_obj.innerHTML = response;
                        var question_name = html_obj.querySelector('.resultsDiv > p').innerHTML;
                        var result_array = JSON.parse(html_obj.querySelector('.resultsDiv script').innerHTML.replace(/.*\[/, '[').replace(/\].*/, ']'));
                        this_component.setState({
                            results: {
                                question_name: question_name,
                                data: result_array
                            }, 
                            results_error: false
                        });
                    },
                    'request_failure': failedResultsRequest,
                    'request_extras': ''
                };

                function failedResultsRequest() {
                    this_component.setState({
                        results_error: true
                    });
                }

                setTimeout(function() {
                    sendXHR(xhr_parameters, 'GET');
                }, 1000);
            }
        }
    }

    getQuestionIds(poll) {
        var question_ids = [];

        if (poll) {
            if (parseInt(poll['poll1ID']) > -1) {
                question_ids.push(poll['poll1ID']);
            }
            if (parseInt(poll['poll2ID']) > -1) {
                question_ids.push(poll['poll2ID']);
            }
        }

        return question_ids;
    }


    renderPollQuestions() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        var poll = this_component.getPoll();

        if (poll !== null) {

            var poll_error = this_component['state']['submit_error'] ? <p className="poll-error">Please enter at least one value</p> : null;

            var question_ids = this.getQuestionIds(poll);

            var poll_questions = question_ids.map(function(question_id, index) {
                var key = index + 1;
                var height_key = 'poll' + key + 'height';
                var iframe_height = poll[height_key] + 'px';
                var iframe_src = configuration['poll']['iframe_url'] + "?pollnumber=" + key + "&pollid=" + poll['id'];
                return (
                    <div key={key} id={"poll-container-" + key}>
                        <iframe src={iframe_src} height={iframe_height} width="250px" scrolling="no" frameBorder="0" title="poll"></iframe>
                    </div>
                );
            });

            return (
                <>
                    {poll_error}
                    {poll_questions}
                    <div className="poll__submit">
                        <input
                            type="submit"
                            className="btn btn-primary"
                            value="Submit"
                            onClick={this_component.clickSubmitHandler}
                            onKeyUp={this_component.keypressHandler}
                        />
                    </div>
                </>
            );
        }
        
        return null;
    }

    renderPollResults() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        var loader = <img src={configuration['images']['loader.gif']['url']} alt="Loading..." />;

        var results = this_component['state']['results'];
        var error = this_component['state']['results_error'];

        var question_name = null;
        var poll_answers = null;

        if (error) {
            poll_answers = <p className="poll-error">Error getting results. Please try again later</p>;
        }
        else if (results) {
            if (results['question_name']) {
                question_name = <p className="modal__text">{results['question_name']}</p>;
            }
            
            
            var result_data = results['data'];
            if (result_data) {
                poll_answers = result_data.map(function(answer, index) {
                    var label = answer['response'];
                    var percent = Math.round(answer['percent_total']) + '%';
                    return (
                        <div key={index} className="poll__option">
                            <span className="poll__key">{label}</span>
                            <span className="poll__value">{percent}</span>
                        </div>
                    )
                });
            } else {
                poll_answers = loader;
            }

        } else {
            poll_answers = loader;
        }

        return (
            <>
                {question_name}
                <div className="poll__results">
                    <div className="poll__summary">
                        {poll_answers}
                    </div>
                </div>
            </>
        );
    }

    renderModalContent() {
        var this_component = this;
        var poll = this_component.getPoll();

        if (poll !== null) {
            var poll_name = poll['name'] ? <span className="modal__subtitle">{poll['name']}</span> : null;
        
            var modal_content = null;
            var poll_is_answered = this['state']['show_results'];
            
            if (poll_is_answered) {
                modal_content = this_component.renderPollResults();
            } else {
                modal_content = this_component.renderPollQuestions();
            }

            return (
                <>
                    {poll_name}
                    {modal_content}
                </>
            );
        }
        
    }

    submitPolls() {
        var this_component = this;
        var portal_context = this_component["context"];
        var helpers = portal_context["helpers"];

        var poll = this_component.getPoll();
        if (poll !== null) {
            var iframe1 = document.querySelector('#poll-container-1 iframe');
            var iframe2 = document.querySelector('#poll-container-2 iframe');

            var iframe1_id = poll['poll1ID'];
            var iframe2_id = poll['poll2ID'];

            var iframe1_body = iframe1.contentDocument || iframe1.contentWindow.document;
            var iframe2_body = iframe2.contentDocument || iframe2.contentWindow.document;

            var checked_input = iframe1_body.querySelector('#rn_spw_0_PollAnswerArea input:checked');

            if (checked_input !== null) {

                var checked_input_id = checked_input.getAttribute('id'); // eg. "q_2763_9115"
                var question = checked_input_id.split('_');

                // Submit poll answer
                iframe1_body.querySelector('.rn_PollSubmitButton').click();
                
                var poll_2_input = iframe2_body.querySelector('#rn_spw_0_PollAnswerArea textarea');
                if (poll_2_input !== null) {
                    var poll_2_answer = poll_2_input.value;
                    if (poll_2_answer.length > 0) {

                        // Submit additional comment
                        iframe2_body.querySelector('.rn_PollSubmitButton').click();
                    }
                }

                this_component.setState({
                    show_results: true,
                    submit_error: false
                });

                var poll_ids = this_component.getCompletePollIds();
                if (poll_ids === null) {
                    poll_ids = [];
                }
                poll_ids.push(
                    {
                        "id": iframe1_id,
                        "qid": question[1]
                    },
                    {
                        "id": iframe2_id
                    }
                );
                
                var polls_complete = {
                    "poll_ids": poll_ids
                };

                var gatekeeper_options = {
                    "source": "setpollscomplete,1",
                    "data": polls_complete,
                    "success": function(response) {
                        var key = squiz['vars']['store_id'] + 'getallstorage';
                        var all_storage = JSON.parse(getStorage('session', key));
                        all_storage['data']['pollscomplete'] = polls_complete;
                        setStorage('session', key, all_storage);
                        
                        this_component.checkForResults();
                        this_component.updateModalContent();
                    }   
                };
                helpers.setGatekeeperData(gatekeeper_options);
            
            
            } else { // No poll value selected
                
                this_component.setState({
                    submit_error: true
                });

            }
        }
    }



    //
    // Render
    //

    render() {
        var this_component = this;

        var has_results = this['state']['show_results'];
        var btn_text = has_results ? 'Poll Results' : 'Poll';
        
        var new_class = !has_results ? ' poll-btn--new' : '';
        var active_class = this['state']['active'] ? ' active' : '';
        var btn_class = 'poll-btn' + active_class + new_class;

        var poll = this_component.getPoll();

        if (poll !== null) {
            return (
                <a href="#" className={btn_class} onClick={this_component.togglePollModal} data-ga-label="Poll">
                    <span className="poll-btn__text">{btn_text}</span>
                </a>
            );

        } else {
            return null;
        }
    }

};

Poll.contextType = PortalContext;
